import { render, staticRenderFns } from "./ProductRecipientDetails.vue?vue&type=template&id=0f2a4927&"
import script from "./ProductRecipientDetails.vue?vue&type=script&lang=js&"
export * from "./ProductRecipientDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecipientDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports